// extracted by mini-css-extract-plugin
module.exports =  {"root":"BefMYD9VXYnod2UTsw2n","description":"VE41KdS6HPfzwl9JiXAd"};